<template>
  <ol class="level-scale" :aria-label="$t(`learnerProfile.${skill}`)">
    <li
      v-for="item in levels"
      :key="item"
      :class="['scale-cell', { current: item === level }]"
      :aria-current="item === level ? 'true' : undefined"
    >
      <span class="scale-code">{{ item }}</span>
      <span class="scale-name">{{ $t(`learnerProfile.levelNames.${item}`) }}</span>
      <span class="scale-description">{{ $t(`learnerProfile.${skill}Levels.${item}`) }}</span>
    </li>
  </ol>
</template>

<script>
import { CEFR_LEVELS } from '@/utils/learnerProfile'

export default {
  name: 'LevelScale',
  props: {
    skill: { type: String, required: true },
    level: { type: String, required: true }
  },
  data() {
    return { levels: CEFR_LEVELS }
  }
}
</script>

<style scoped>
.level-scale {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.scale-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-3);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
}

.scale-cell.current {
  border-color: var(--border-active);
  background: var(--surface-active);
}

.scale-code {
  color: var(--ink-tertiary);
  font-family: var(--font-family-data);
  font-size: var(--font-size-sm);
  font-weight: 600;
}

.current .scale-code {
  color: var(--signal-active-strong);
}

.scale-name {
  color: var(--ink-primary);
  font-size: var(--font-size-sm);
  font-weight: 500;
}

.scale-description {
  color: var(--ink-secondary);
  font-size: var(--font-size-xs);
  line-height: 1.45;
}

@media (max-width: 640px) {
  .level-scale {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
